import React from 'react';

export function SkipNavigation() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 bg-figma-primary text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-white"
    >
      Saltar al contenido principal
    </a>
  );
}